<template>
  <div v-if="element" class="element-wrapper">
    <img :style="`width:100%; height:100%; opacity: ${element.opacity / 100};`" :src="handleRepairePublicPrefix(element.imgSrc)" @click="handleElementClick">
  </div>
</template>

<script>
import 'view-design/dist/styles/iview.css'
import { handleRepairePublicPrefix } from '@/util'

export default {
  name: 'CompPicture',
  methods: {
    handleElementFunsInit () {
      const ele = this.$el
      const _key = this.element._key
      const eventsBinding = this.element.eventsBinding || null
      if (!eventsBinding || !eventsBinding.list || eventsBinding.list.length < 1) return
      this.eventsBinding = eventsBinding
      ele.addEventListener('click', this.handleElementClick)
    },
    handleElementClick (ev) {
      // ev.stopPropagation()
      this.$blueMap.trigger({
        nodeType: 'plugin',
        pluginId: this.element.id,
        dataKey: 'onclick',
        eventData: {
          value: null,
          data: this.plugin,
          event: ev
        }
      })
    }
  },
  beforeDestroy () {
    this.$ele && this.$ele.removeEventListener('click', this.handleElementClick)
  },
  props: {
    element: {
      type: Object,
      default: null,
      require: true
    }
  },
  data: () => {
    return {
      eventsBinding: null,
      handleRepairePublicPrefix
    }
  },
  computed: {
    plugin: function() {
      return this.$getPlugin(this.element.id)
    }
  },
  mounted() {
    this.$nextTick(() => {
      // this.handleElementFunsInit()
      this.$blueMap.trigger({
      nodeType: 'plugin',
      pluginId: this.element.id,
      dataKey: 'onmounted',
      eventData: {
        value: null,
        data: this.plugin,
        event: null
        }
      })
    })
  }
}
</script>

<style lang='less' scoped>
.element-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
}
</style>
